<script lang="ts">
  /**
   * T28 — ReportPage.svelte
   * Página principal de exportação do relatório.
   * Props: result: DiagnosticResult
   * Layout: ReportActions no topo, PrintableReport abaixo.
   */
  import type { DiagnosticResult } from '$core/diagnostic.types';
  import type { ReportModelT27 } from '$core/report/report.types';
  import { buildReportModel } from '$core/report/reportModel';
  import ReportActions from './ReportActions.svelte';
  import PrintableReport from './PrintableReport.svelte';

  export let result: DiagnosticResult;

  $: report = buildReportModel(result) as ReportModelT27;
</script>

<div class="report-page">
  <header class="report-page__header">
    <h1 class="report-page__title">Relatório do Diagnóstico</h1>
    <p class="report-page__subtitle">
      Período: <strong>{report.periodLabel}</strong>
    </p>
  </header>

  <div class="report-page__actions">
    <ReportActions {report} />
  </div>

  <div class="report-page__content" aria-label="Relatório completo">
    <PrintableReport {report} />
  </div>
</div>

<style>
  .report-page {
    display: flex;
    flex-direction: column;
    gap: var(--ptt-space-5, 1.25rem);
    max-width: 960px;
    margin: 0 auto;
    padding: var(--ptt-space-6, 1.5rem) var(--ptt-space-5, 1.25rem);
  }

  .report-page__header {
    display: flex;
    flex-direction: column;
    gap: var(--ptt-space-1, 0.25rem);
  }

  .report-page__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--ptt-black, #000000);
    margin: 0;
  }

  .report-page__subtitle {
    font-size: 0.9rem;
    color: var(--ptt-gray-200, #565656);
    margin: 0;
  }

  .report-page__content {
    border-top: 2px solid var(--ptt-gray-20, #e7e7e7);
    padding-top: var(--ptt-space-5, 1.25rem);
  }

  @media (max-width: 768px) {
    .report-page {
      padding: var(--ptt-space-4, 1rem) var(--ptt-space-3, 0.75rem);
    }
  }

  @media print {
    .report-page {
      padding: 0;
      gap: 0;
    }

    .report-page__header {
      display: none;
    }

    .report-page__actions {
      display: none;
    }

    .report-page__content {
      border-top: none;
      padding-top: 0;
    }
  }
</style>
